import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename", "panel", "label"];
import { useEffect, memo } from 'react';
import { Input, useStore } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Username = /*#__PURE__*/memo(props => {
  var {
      keyname = 'username',
      name,
      rename,
      panel = 'login',
      label = 'Username'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    dispatch
  } = useStore();
  var panelName = panel;
  var key = keyname || name;
  useEffect(() => dispatch({
    ["$$" + panelName + key]: label
  }), [label]);
  var nameBase = name || rename || keyname;
  return /*#__PURE__*/_jsx(Input, _extends({
    placeholder: "Username",
    spellCheck: false
  }, elmProps, {
    name: nameBase,
    keyname: "$$" + panelName + key
  }));
});
Username.displayName = 'Login.Username';